module.exports = __webpack_public_path__ + "img/svg/icon-prizes.27e3cdf2439cc77a349e623929036d28.svg";